<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value" style="width: 446px;">
            <label><input :disabled="disabled" type="checkbox" v-model="useFrom" @change="syncModel"/> 从</label>
            <el-input type="number" size="small" :disabled="disabled || !useFrom" v-model.number="curValue.from" align="right" style="width: 170px;" @change="syncModel"></el-input>
            <label><input :disabled="disabled" type="checkbox" v-model="useTo" @change="syncModel"/> 至</label>
            <el-input type="number" size="small" :disabled="disabled || !useTo" v-model.number="curValue.to" align="right" style="width: 170px;" @change="syncModel"></el-input>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //有效的值类型
    let validValueTypes = ['Integer', 'Float'];

    function isValidValueType(valueType) {
        return validValueTypes.indexOf(valueType) != -1;
    }

    function getModelResultValue(curValue, valueType) {
        let resultValue = curValue;
        if(resultValue != null) {
            resultValue = valueType == 'Float' ? Utils.ParseFloat(resultValue) : Utils.ParseInt(resultValue);
        }
        return resultValue;
    }

    //
    export default {
        name: 'swb-query-num2-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'Integer'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            iniValue: {
                default: null
            }
        },
        //
        data() {
            return {
                useFrom: false,
                useTo: false,
                //
                curValue: {
                    from: null,
                    to: null
                }
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            iniValue(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        //
        methods: {
            init() {
                if(!isValidValueType(this.valueType)) {
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    }
                    else {
                        MsgBox.error(message);
                    }
                }
                //
                this.curValue = {
                    from: null,
                    to: null
                };
                //
                let iniValue = this.iniValue || {};
                this.useFrom = iniValue.from != null;
                this.useTo = iniValue.to != null;
                //初始化
                this.curValue = Utils.merge(this.curValue, iniValue);
                this.syncModel();
            },
            syncModel() {
                let resultValue = {};
                if(this.useFrom) {
                    resultValue.from = getModelResultValue(this.curValue.from, this.valueType);
                }
                if(this.useTo) {
                    resultValue.to = getModelResultValue(this.curValue.to, this.valueType);
                }
                this.curValue = Utils.merge({}, resultValue);
                //
                this.$emit('input', resultValue);
            }
        }
    }

</script>

<style scoped>

    .shortcut-item:hover {
        background-color: #FFEFC1;
    }

    .shortcut-item-sepline {
        border-bottom: 1px dashed #d7d4f0;
    }

</style>



// WEBPACK FOOTER //
// src/compo/query/QueryNum2Field.vue